import styled, { css } from 'styled-components';
import { desktop_small, mobile_xl } from '../../../global/mediaQueryMixin';

const Main = styled.div`
  display: flex;
  gap: var(--space-20);
  ${desktop_small(css`
    flex-wrap: wrap;
  `)}
  ${mobile_xl(css`
    gap: var(--space-16);
  `)}
  .loading-animation {
    overflow: hidden;
  }
  .loading-animation::before {
    content: '';
    display: block;
    height: 100%;
    width: 100%;
    animation: loading 1s infinite;
    background: linear-gradient(to right, transparent, var(--background-tertiary), transparent);
  }

  @keyframes loading {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }
`;
const First = styled.div`
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-12);
  max-width: 240px;
  width: 100%;
  background-color: var(--background-primary);
  ${mobile_xl(css`
    max-width: -webkit-fill-available;
  `)}
`;
const Top = styled.div`
  padding: var(--space-16) var(--space-20);
  display: flex;
  flex-direction: column;
  gap: var(--space-12);
`;

const Bottom = styled.div`
  padding: var(--space-16) var(--space-24);
  display: flex;
`;

const Circle = styled.div`
  width: 28px;
  height: 28px;
  border-radius: var(--border-radius-full);
  border: 3px solid var(--background-primary);
  background: var(--background-muted);
  margin-left: -8px;
`;

const Line = styled.div`
  background-color: var(--background-muted);
  height: 1px;
  width: 240px;
  ${mobile_xl(css`
    width: auto;
  `)}
`;

const FirstLine = styled.div`
  width: 140px;
  height: 10px;
  background: var(--background-muted);
  border-radius: var(--border-radius-full);
`;

const SecondLine = styled.div`
  width: 180px;
  height: 8px;
  background: var(--background-muted);
  border-radius: var(--border-radius-full);
`;

const ThirdLine = styled.div`
  width: 180px;
  height: 6px;
  background: var(--background-muted);
  border-radius: var(--border-radius-8);
  margin-top: var(--space-20);
`;

export { Main, Top, Bottom, Line, Circle, First, FirstLine, SecondLine, ThirdLine };
